import * as React from 'react';

import { NotificationTypeV1 } from '@oneaudi/audi-notification-display-service';

import { ThemeProvider } from '@oneaudi/unified-web-common';
import { Text } from '@oneaudi/unified-web-components';
import { ContextValue, withContext } from '../../context';
import { Notification } from '../../feature-service-types';

import { PopupGroup } from './popup-group';
import { PopupTransitionGroup } from './transition-group';
import { PopUpTransition } from './transition';
import { PopupNotification, PopupNotificationType } from './notification';
import { getThemeName } from '../../utils/alpha-helpers';

export interface PopupNotificationListProps {
  notifications: Notification[];
}

const notificationTypeMapping: { [type in NotificationTypeV1]: PopupNotificationType } = {
  [NotificationTypeV1.POPUP_ERROR]: PopupNotificationType.ERROR,
  [NotificationTypeV1.POPUP_SUCCESS]: PopupNotificationType.SUCCESS,
  [NotificationTypeV1.POPUP_GENERIC]: PopupNotificationType.GENERIC,
};

export const PopupNotificationList: React.FunctionComponent<PopupNotificationListProps> =
  withContext(({ notifications, i18n }: PopupNotificationListProps & ContextValue) => {
    return (
      <ThemeProvider theme={{ name: getThemeName() }}>
        <PopupGroup>
          <PopupTransitionGroup>
            {notifications?.map((notification) => (
              <PopUpTransition key={notification.id}>
                <PopupNotification
                  notificationId={notification.id}
                  type={notificationTypeMapping[notification.type]}
                  closeLabel={i18n.closeButton()}
                  {...notification.options}
                  onClose={notification.handleUserClose}
                >
                  {typeof notification.content === 'string' ? (
                    <Text tag="p" variant={{ order: '2', style: 'normal' }}>
                      {notification.content}
                    </Text>
                  ) : (
                    notification.content
                  )}
                </PopupNotification>
              </PopUpTransition>
            ))}
          </PopupTransitionGroup>
        </PopupGroup>
      </ThemeProvider>
    );
  });
